import { makeStyles } from '@material-ui/core/styles';

import bgImage from 'assets/images/bgLogin.jpg';

export default makeStyles((theme) => ({
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },

  container: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
  },

  card: {
    animation: '$fadeIn 0.6s ease-out',
    maxWidth: 400,
    width: '100%',
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius * 6,
    boxShadow: theme.shadows[12],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 254, 254, 0.8)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
  },

  logoWrapper: {
    marginBottom: theme.spacing(3),
  },

  logo: {
    width: 200,
    height: 'auto',
  },

  title: {
    fontWeight: 600,
    color: '#512da8',
    marginBottom: theme.spacing(1),
  },

  subtitle: {
    color: '#444444',
    marginBottom: theme.spacing(0.5),
  },

  byline: {
    color: '#777777',
    marginBottom: theme.spacing(2),
  },

  flai: {
    color: '#512da8',
  },

  icons: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    '& > *': {
      margin: theme.spacing(0, 1),
    },
  },

  icon: {
    fontSize: '1.6rem',
    color: '#888888',
    cursor: 'pointer',
    transition: 'color 0.2s',
    '&:hover': {
      color: '#512da8',
    },
  },

  '@global': {
    'input:focus': {
      borderColor: '#512da8',
      boxShadow: '0 0 4px rgba(81,45,168,0.4)',
    },
  },
}));
